<div class='poam-component' style='height: 100%'>
  <p-table [value]="projectControlItems"
           [style]="{'margin-top':'10px', 'white-space':'nowrap'}" sortField="deviceId"
           [rows]="20"
           [paginator]="true"
           [pageLinks]="5"
           #devicesTable>

    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [pSortableColumn]="col.field" pResizableColumn
            [ngStyle]="{'width': col.width || 'auto'}" style="font-weight: bold; text-align: center;">
          {{col.header}}
          <p-sortIcon [field]="col.field" ariaLabel="Activate to sort"
                      ariaLabelDesc="Activate to sort in descending order"
                      ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
        </th>
      </tr>
      <tr>
        <th *ngFor="let col of cols">
          <input pInputText type="text" placeholder="⌕"
                 (input)="devicesTable.filter($event.target['value'], col.field, 'contains')">
        </th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
      <tr>
        <td><a [routerLink]="['/projects', 'project', item.projectId]">{{item.projectName}}</a></td>
        <td>{{item.controlItem.category}}</td>
        <td><a [routerLink]="['/projects', 'project', item.projectId, item.projectControlItemId]">{{item.controlItem.complianceAreaControlId}}</a></td>
        <td><div style="overflow: hidden; text-overflow: ellipsis; max-width: 300px; white-space: nowrap;" [attr.tooltip]="item.solutionDescriptionText">{{item.solutionDescriptionText}}</div></td>
        <td>{{item.inheritedControls}}</td>
      </tr>
    </ng-template>

  </p-table>
</div>
